import React from 'react';
import cn from 'classnames';

import {isProductSearchHitModel} from 'coreClasses/search/ProductSearchHitModel';

import ProductBadges from 'brandComponents/product/ProductBadges';

import {useProductHitContext} from '../../ProductHitContext';

import {IProductHitBadges} from './IProductHitBadges';

import styles from './ProductHitBadges.module.scss';

const ProductHitBadges = ({classNames}: IProductHitBadges) => {
	const {product} = useProductHitContext();

	if (!product || isProductSearchHitModel(product)) {
		return null;
	}

	const badges = product.getBadgesIds() || [];

	if (!badges.length) {
		return null;
	}

	return (
		<ProductBadges
			badgesList={badges}
			className={cn(
				styles['product-hit__badges'],
				classNames,
			)}
		/>
	);
};

export default ProductHitBadges;
